import { forwardRef } from 'react';

import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import StyledStack from './styles';
import { Props } from './types';
import Text from '../text';

const Input = forwardRef<HTMLDivElement, Props>(
  ({ helperText, error, label, fullWidth, ...otherProps }, ref) => {
    return (
      <StyledStack fullWidth={fullWidth}>
        {label && (
          <Text
            variant="textSm"
            weight="medium"
            component="label"
          >
            {label}
          </Text>
        )}
        <OutlinedInput
          {...otherProps}
          fullWidth={fullWidth}
          ref={ref}
          error={error}
        />
        {helperText && <FormHelperText error>{helperText}</FormHelperText>}
      </StyledStack>
    );
  },
);

Input.displayName = 'Input';

export default Input;
